import { render, staticRenderFns } from "./AddApartment.vue?vue&type=template&id=72fb2137&scoped=true&"
import script from "./AddApartment.vue?vue&type=script&lang=js&"
export * from "./AddApartment.vue?vue&type=script&lang=js&"
import style0 from "./AddApartment.vue?vue&type=style&index=0&id=72fb2137&scoped=true&lang=css&"
import style1 from "./AddApartment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb2137",
  null
  
)

export default component.exports